import { FontAwesomeIcon } from 'components/ui/FontAwesomeIcon';
import * as React from 'react';
import { Button, CardBody, CardFooter, Col, Form, Input, Row } from 'reactstrap';
import { HttpRequest } from '../../../util/http';
import { IHierarchy } from '../interfaces';

interface IHierarchyEditProps {
  editMode?: IHierarchy
  onCancel?: () => void
  onSuccess?: () => Promise<void> | void
}

interface IHierarchyEditorState {
  hierarchy: string
  sort_order: number
  isSubmitting: boolean
}

export class HierarchyEditor extends React.Component<IHierarchyEditProps, IHierarchyEditorState> {
  initState: IHierarchyEditorState = {
    hierarchy: '',
    sort_order: 0,
    isSubmitting: false
  }

  state: IHierarchyEditorState = { ...this.initState }

  componentWillMount() {
    const { editMode } = this.props

    if (editMode) {
      const { hierarchy, sort_order } = editMode

      this.setState({ hierarchy, sort_order })
    }
  }

  isEditMode() {
    return typeof this.props.editMode === 'object'
  }

  submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    const method = 'POST'
    const { onSuccess } = this.props
    const { hierarchy, sort_order: sort } = this.state
    const endpoint = `/scripts/hierarchies/${this.isEditMode() ? 'modify' : 'add'}`
    const data = { hierarchy, sort };

    this.setState({ isSubmitting: true })

    HttpRequest.fetch(endpoint, { data, method })
      .then(() => {
        let onSuccessPromise = onSuccess()

        if (!onSuccessPromise) {
          onSuccessPromise = Promise.resolve()
        }

        return onSuccessPromise.then(() => this.resetToInitState())
      })
      .finally(() => this.setState({ isSubmitting: false }))
  }

  resetToInitState() {
    this.setState({ ...this.initState })
  }

  onSortOrderChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { value } = e.target

    // tslint:disable-next-line:variable-name
    let sort_order = Number(value)

    if (isNaN(sort_order)) {
      sort_order = 0
    }

    this.setState({ sort_order })
  }

  render() {
    const { isSubmitting } = this.state
    const { onCancel } = this.props

    return (
      <Form onSubmit={(e) => this.submit(e)}>
        <CardBody className="bg-white">
          <Row>
            <Col md={6}>
              <label>Hierarchy Name</label>
              <Input type="text" required
                value={this.state.hierarchy}
                readOnly={isSubmitting}
                onChange={(e) => this.setState({ hierarchy: e.target.value })}
                disabled={this.isEditMode()} />
            </Col>
            <Col md={6}>
              <label>Sort Order</label>
              <Input type="number" required
                readOnly={isSubmitting}
                value={String(this.state.sort_order)}
                onChange={(e) => this.onSortOrderChange(e)} />
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="d-flex justify-content-end">
          <Button color="primary" className="mr-2" type="submit"
            readOnly={isSubmitting}>
            <span>Submit&nbsp;</span>
            {isSubmitting &&
              <FontAwesomeIcon icon="cog" spin />
            }
          </Button>
          <Button color="light"
            onClick={() => onCancel && onCancel()}
            readOnly={isSubmitting}>
            <span>Cancel</span>
          </Button>
        </CardFooter>
      </Form>
    )
  }
}
